import { render, staticRenderFns } from "./DxfViewer.vue?vue&type=template&id=46e5c0f0&scoped=true&"
import script from "./DxfViewer.vue?vue&type=script&lang=js&"
export * from "./DxfViewer.vue?vue&type=script&lang=js&"
import style0 from "./DxfViewer.vue?vue&type=style&index=0&id=46e5c0f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e5c0f0",
  null
  
)

export default component.exports